<template>
  <main id="content">
    <section class="pt-4 pb-4">
      <b-container style="max-width: 900px">
        <b-row>
          <b-col md="4">
            <SettingsNav />
          </b-col>
          <b-col md="8">
            <div class="card card-body" data-aos="fade-down-left">
              <h2 class="h4 mb-3">Customer Info</h2>
              <div
                v-if="loading"
                class="d-flex justify-content-center pt-5 pb-5 text-muted"
              >
                <font-awesome-icon icon="sync" size="2x" spin />
              </div>
              <div v-else>
                <b-row>
                  <b-col cols="6" class="mb-3">
                    <div class="font-weight-bold">Card status</div>
                    <div>
                      <span style="text-transform: capitalize">
                        {{ details.card_status.replace(/_/g, " ") }}
                      </span>
                      (
                      <router-link
                        id="hyperCustomerCardEdit"
                        to="/settings/payment"
                        >Edit</router-link
                      >)
                    </div>
                  </b-col>
                  <b-col cols="6" class="mb-3">
                    <div class="font-weight-bold">Promotional credits</div>
                    <div>${{ details.promotional_credits / 100 }}</div>
                  </b-col>
                  <b-col cols="6">
                    <div class="font-weight-bold">Excess payments</div>
                    <div>${{ details.excess_payments / 100 }}</div>
                  </b-col>
                  <b-col cols="6">
                    <div class="font-weight-bold">Unbilled charges</div>
                    <div>${{ details.unbilled_charges / 100 }}</div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="card card-body" data-aos="fade-up-left">
              <h2 class="h4 mb-3">Billing Details</h2>
              <div
                v-if="loading"
                class="d-flex justify-content-center pt-5 pb-5 text-muted"
              >
                <font-awesome-icon icon="sync" size="2x" spin />
              </div>
              <b-form v-else @submit.prevent="billingAction">
                <b-row>
                  <b-col md>
                    <b-form-group label="First name">
                      <b-form-input
                        id="txtBillingCustomerFirstName"
                        type="text"
                        v-model="settings.firstName"
                        placeholder="Enter your first name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md>
                    <b-form-group label="Last name">
                      <b-form-input
                        id="txtBillingCustomerLastName"
                        type="text"
                        v-model="settings.lastName"
                        placeholder="Enter your last name"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group label="Phone">
                  <b-form-input
                    id="txtBillingCustomerPhone"
                    type="text"
                    v-model="settings.phone"
                    placeholder="Enter your phone number"
                  />
                </b-form-group>
                <b-form-group label="Company">
                  <b-form-input
                    id="txtBillingCustomerCompany"
                    type="text"
                    v-model="settings.company"
                    placeholder="Enter your company name"
                  />
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    id="checkBillingDetailCheckBox"
                    v-model="settings.auto_collection"
                    value="on"
                    unchecked-value="off"
                  >
                    Automatically charge my payment method on invoicing
                  </b-form-checkbox>
                </b-form-group>
                <transition name="fade">
                  <b-button
                    id="btnBillingDetailUpdateSettings"
                    type="submit"
                    variant="primary"
                  >
                    <span v-if="show">
                      Update settings
                      <font-awesome-icon icon="arrow-right" />
                    </span>
                    <span v-else>
                      Updating settings &nbsp;
                      <font-awesome-icon icon="sync" spin />
                    </span>
                  </b-button>
                </transition>
              </b-form>
            </div>
            <div class="card card-body" data-aos="fade-down-left">
              <h2 class="h4 mb-3">Billing Address</h2>
              <div
                v-if="loading"
                class="d-flex justify-content-center pt-5 pb-5 text-muted"
              >
                <font-awesome-icon icon="sync" size="2x" spin />
              </div>
              <b-form v-else @submit.prevent="billingAction">
                <b-form-group label="Address number/floor/suite">
                  <b-form-input
                    id="txtBillingAddressNumber"
                    type="text"
                    v-model="settings.address1"
                    placeholder="Enter your address line 1"
                  />
                </b-form-group>
                <b-form-group label="Street">
                  <b-form-input
                    id="txtBillingAddressStreet"
                    type="text"
                    v-model="settings.address2"
                    placeholder="Enter your address line 2"
                  />
                </b-form-group>
                <b-form-group label="City">
                  <b-form-input
                    id="txtBillingAddressCity"
                    type="text"
                    v-model="settings.city"
                    placeholder="Enter your city name"
                  />
                </b-form-group>
                <b-row>
                  <b-col md>
                    <b-form-group label="State">
                      <b-form-input
                        id="txtBillingAddressState"
                        type="text"
                        v-model="settings.state"
                        placeholder="State name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md>
                    <b-form-group label="ZIP">
                      <b-form-input
                        id="txtBillingAddressZip"
                        type="text"
                        v-model="settings.zip"
                        placeholder="PIN/ZIP code"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <transition name="fade">
                  <b-button
                    id="btnBillingAddressUpdateSettings"
                    type="submit"
                    variant="primary"
                  >
                    <span v-if="show">
                      Update settings
                      <font-awesome-icon icon="arrow-right" />
                    </span>
                    <span v-else>
                      Updating settings &nbsp;
                      <font-awesome-icon icon="sync" spin />
                    </span>
                  </b-button>
                </transition>
                <!-- Separate synchronisation for both sections of settings updates -->
              </b-form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import {
  getStripeCustomerDetails,
  updateStripeCustomerDetails
} from "../modules/database";
import constants from "../modules/constants";
import SettingsNav from "../components/SettingsNav.vue";
export default {
  data: () => {
    return {
      settings: {
        firstName: "",
        lastName: "",
        phone: "",
        company: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        auto_collection: "on"
      },
      details: {
        card_status: "",
        promotional_credits: 0,
        excess_payments: 0,
        unbilled_charges: 0
      },
      show: true,
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    getStripeCustomerDetails()
      .then(info => {
        if (info.card_status) this.details.card_status = info.card_status;
        if (info.promotional_credits)
          this.details.promotional_credits = info.promotional_credits;
        if (info.excess_payments)
          this.details.excess_payments = info.excess_payments;
        if (info.unbilled_charges)
          this.details.unbilled_charges = info.unbilled_charges;
        if (info.metadata.first_name)
          this.settings.firstName = info.metadata.first_name;
        if (info.metadata.last_name)
          this.settings.lastName = info.metadata.last_name;
        if (info.metadata.phone) this.settings.phone = info.metadata.phone;
        if (info.metadata.company)
          this.settings.company = info.metadata.company;
        if (info.metadata.auto_collection)
          this.settings.auto_collection = info.metadata.auto_collection;
        if (info.shipping.address) {
          if (info.shipping.address.line1)
            this.settings.address1 = info.shipping.address.line1;
          if (info.shipping.address.line2)
            this.settings.address2 = info.shipping.address.line2;
          if (info.shipping.address.city)
            this.settings.city = info.shipping.address.city;
          if (info.shipping.address.state)
            this.settings.state = info.shipping.address.state;
          if (info.shipping.address.postal_code)
            this.settings.zip = info.shipping.address.postal_code;
        }
      })
      .catch(error => {
        console.log("error", error);
      })
      .finally(() => {
        this.loading = false;
        if (!(this.settings.city || this.settings.state || this.settings.zip)) {
          fetch("https://freegeoip.live/json/")
            .then(response => response.json())
            .then(json => {
              if (json.city) this.settings.city = json.city;
              if (json.region_name) this.settings.state = json.region_name;
              if (json.zip_code) this.settings.zip = json.zip_code;
            });
        }
      });
  },
  methods: {
    billingAction() {
      this.show = false;
      updateStripeCustomerDetails(
        this.settings.firstName,
        this.settings.lastName,
        this.settings.phone,
        this.settings.company,
        this.settings.address1,
        this.settings.address2,
        this.settings.city,
        this.settings.state,
        this.settings.zip,
        this.settings.auto_collection
      )
        .then(info => {
          this.show = true;
          this.$root.toast(constants.info.billing_info_updated);
          if (info.metadata.first_name)
            this.settings.firstName = info.metadata.first_name;
          if (info.metadata.last_name)
            this.settings.lastName = info.metadata.last_name;
          if (info.metadata.phone) this.settings.phone = info.metadata.phone;
          if (info.metadata.company)
            this.settings.company = info.metadata.company;
          if (info.metadata.auto_collection)
            this.settings.auto_collection = info.metadata.auto_collection;
          if (info.shipping.address) {
            if (info.shipping.address.line1)
              this.settings.address1 = info.shipping.address.line1;
            if (info.shipping.address.line2)
              this.settings.address2 = info.shipping.address.line2;
            if (info.shipping.address.city)
              this.settings.city = info.shipping.address.city;
            if (info.shipping.address.state)
              this.settings.state = info.shipping.address.state;
            if (info.shipping.address.postal_code)
              this.settings.zip = info.shipping.address.postal_code;
          }
        })
        .catch(error => {
          console.log("error", error);
          this.$root.toast(constants.errors.settings_error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: {
    SettingsNav
  }
};
</script>
